export const SET_ENV = "SET_ENV";

export const setEnv = (payload) => {
  return {
    type: SET_ENV,
    payload,
  };
};
